import React from 'react';
const cardData = [
  {
    id: 1,
    question: 'What?',
    text: 'An immersive live industry project as per the domain of the upskilling course',
  },
  {
    id: 2,
    question: 'Why?',
    text: 'It acts as an enabler in building proof of work, showcasing domain knowledge, and demonstrating skill expertise',
  },
  {
    id: 3,
    question: 'How?',
    text: 'The allocated project consists of multiple tasks that you can access and submit',
  },
];

const CompanyProject = () => {
  return (
    <div className='mt-4 md:mt-6'>
      <p className='font-semibold'>Company Project</p>
      <div className='grid grid-cols-1 xl:grid-cols-3 gap-4  xl:gap-12 lg:w-[90%] lg:mr-auto mt-6'>
        {cardData.map((data) => (
          <div
            key={data.id}
            className='flex space-x-2 items-center lg:items-start border rounded-lg p-2 md:p-4 '
          >
            <div className='flex-none font-semibold bg-primary-light  text-white h-12 md:h-14 w-12 md:w-14 text-sm flex items-center my-auto justify-center rounded-full'>
              {data.question}
            </div>
            <p className='text-sm pl-2 '>{data.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyProject;
